<div class="col">
  <div class="row justify-content-center g-4 p-4">
    @for (category of categories; track $index) {
    <div class="col-auto">
      <button 
        type="button" 
        class="btn btn-secondary btn-lg rounded-3" 
        (click)="selectCategory(category)"
        [ngClass]="{'selected': containsCategory(category)}"
      >
        <input class="form-check-input pe-none" type="checkbox" value="" [attr.checked]="containsCategory(category) ? true : null">
        {{ category.name }} 
        <span class="badge text-bg-primary rounded-circle">{{ category.count }}</span>
      </button>
    </div>
    }
  </div>

  <div class="row justify-content-between g-4 p-4">
    <div class="col-auto">
      <h3 class="font-size-36">Available Products</h3>
    </div>
    <div class="col-auto">
      <h3 class="font-size-36">{{products.length}} Products</h3>
    </div>
  </div>

  @if (empty()) {
    <div class="row">
      <div class="col-3 mx-auto">
          <div class="row g-0 my-1">
              <h1 class="text-center">No Available Products</h1>
          </div>
          <div class="row g-0 my-1">
              <span class="text-center font-size-16">Check back later for more.</span>
          </div>
      </div>
    </div>
  }

  <div class="row row-cols-3 g-4 p-4" >
    @for (product of products; track $index) {
    <div class="col-12 col-md-4"
      *ngIf="containsProduct(product) || selectedCategories.length === 0"
    >
      <div class="card h-100 border-0">
        @if (product.imgUrls) {
          <ngb-carousel>
            @for (imgUrl of product.imgUrls; track imgUrl) {
              <ng-template ngbSlide>
                <div class="picsum-img-wrapper">
                  <img src="https://cdn.wyvern-weaponry.com/{{ imgUrl }}" class="d-block w-100 crop card-img-top crop rounded-top-4" alt="...">
                </div>
              </ng-template>
            }
          </ngb-carousel>
        }
        
        <div class="position-absolute mt-3 bg-primary p-1 rounded-3">
          <div class="row justify-content-center p-1 g-1">
            <div class="font-size-16 text-white col-auto"> Qty: {{ product.quantity }} </div>
          </div>
        </div>
        
        <div class="card-body">
          <div class="row justify-content-between">
            <h5 class="card-title font-size-32 col-auto">{{ product.productName }}</h5>
            <h5 class="card-title font-size-32 col-auto">${{ product.price / 100 }}</h5>
          </div>
          <div class="d-grid gap-2">
            <button type="button" class="btn btn-primary btn-lg rounded-3 font-size-20" [routerLink]="['/product', product.id]">More...</button>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
